import { Box, Container, Grid, Stack, Typography } from '@mui/material';

interface CityTile {
  name: string;
  imageUrl: string;
  /** Subtitle, e.g. "320 properties". */
  subtitle?: string;
}

interface OtaPopularCitiesProps {
  cities?: CityTile[];
  onCityClick?: (city: string) => void;
}

const DEFAULT_CITIES: CityTile[] = [
  { name: 'Bengaluru', imageUrl: 'https://images.unsplash.com/photo-1570168007204-dfb528c6958f?w=600&q=80', subtitle: 'Tech capital · 320+ stays' },
  { name: 'Mumbai',    imageUrl: 'https://images.unsplash.com/photo-1567157577867-05ccb1388e66?w=600&q=80',    subtitle: 'City of dreams · 410+ stays' },
  { name: 'Goa',       imageUrl: 'https://images.unsplash.com/photo-1512343879784-a960bf40e7f2?w=600&q=80',     subtitle: 'Beaches · 280+ stays' },
  { name: 'Udaipur',   imageUrl: 'https://images.unsplash.com/photo-1599661046289-e31897846e41?w=600&q=80',     subtitle: 'Royal heritage · 140+ stays' },
  { name: 'Jaipur',    imageUrl: 'https://images.unsplash.com/photo-1599661046289-e31897846e41?w=600&q=80',     subtitle: 'Pink city · 220+ stays' },
  { name: 'Manali',    imageUrl: 'https://images.unsplash.com/photo-1626621341517-bbf3d9990a23?w=600&q=80',     subtitle: 'Mountains · 180+ stays' },
];

export function OtaPopularCities({ cities = DEFAULT_CITIES, onCityClick }: OtaPopularCitiesProps) {
  return (
    <Box sx={{ py: { xs: 6, md: 10 }, bgcolor: 'background.subtle' }}>
      <Container maxWidth="xl">
        <Stack spacing={1} sx={{ mb: { xs: 3, md: 4 } }}>
          <Typography variant="overline" color="secondary.main">
            Popular destinations
          </Typography>
          <Typography variant="h3">Where travelers are heading</Typography>
          <Typography variant="body1" color="text.secondary">
            Tap a city to browse hand-picked stays.
          </Typography>
        </Stack>

        <Grid container spacing={2.5}>
          {cities.map((c, idx) => (
            <Grid key={c.name} item xs={6} sm={4} md={idx < 2 ? 4 : 2}>
              <Box
                onClick={() => onCityClick?.(c.name)}
                sx={{
                  position: 'relative',
                  height: { xs: 160, sm: 180, md: idx < 2 ? 220 : 180 },
                  borderRadius: 3,
                  overflow: 'hidden',
                  cursor: 'pointer',
                  backgroundImage: `url(${c.imageUrl})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-4px) scale(1.01)',
                    boxShadow: '0 18px 36px rgba(15, 23, 42, 0.20)',
                  },
                  '&::before': {
                    content: '""',
                    position: 'absolute',
                    inset: 0,
                    background: 'linear-gradient(180deg, rgba(0,0,0,0) 40%, rgba(0,0,0,0.65) 100%)',
                  },
                }}
              >
                <Stack
                  sx={{
                    position: 'absolute',
                    inset: 0,
                    p: 2.5,
                    justifyContent: 'flex-end',
                    color: '#fff',
                  }}
                >
                  <Typography variant="h5" sx={{ fontWeight: 700, color: '#fff', textShadow: '0 1px 4px rgba(0,0,0,0.3)' }}>
                    {c.name}
                  </Typography>
                  {c.subtitle && (
                    <Typography variant="caption" sx={{ color: '#E0E8F0', textShadow: '0 1px 4px rgba(0,0,0,0.4)' }}>
                      {c.subtitle}
                    </Typography>
                  )}
                </Stack>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
